import React, { Component } from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { Header, Footer, LiveChat, Spinner } from "./components";
import { Home, VerifyEmail } from "./views";

class App extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired
  };

  state = {
    profile: {}
  };

  componentWillMount() {
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile }, () => this.gotEmail(profile.email));
      });
    } else {
      this.setState({ profile: userProfile }, () =>
        this.gotEmail(userProfile.email)
      );
    }
  }

  gotEmail = email => {
    //do stuff once email is fetched from auth token endpoint
    //analytics?, user settings?
    // /* Create a timer to store the users settings on a regular interval  */
    // setInterval(this.saveUserSettings, config.userSettingSaveInterval);
    //create Apps API instance
    const idToken = localStorage.getItem("id_token");

    const appsAPI = axios.create({
      baseURL: "https://api.apps.pdview.com.au",
      headers: {
        Authorization: `Bearer ${idToken}`
      }
    });

    this.setState({
      appsAPI
    });
  };

  appContent = view => {
    const { profile, appsAPI } = this.state;
    switch (view) {
      case "home":
        if (profile && profile.email && appsAPI)
          return (
            <Home
              email={profile.email}
              name={profile.nickname ? profile.nickname : profile.name}
              picture={profile.picture}
              appsAPI={appsAPI}
            />
          );
        else return <Spinner message="Loading user information" />;
      case "verifyemail":
        if (profile && profile.email && appsAPI)
          return <VerifyEmail email={profile.email} appsAPI={appsAPI} />;
        else return <Spinner message="Loading user information" />;
      default:
        return <Redirect to="/app/home" />; //or last visited view
    }
  };

  render() {
    const { profile } = this.state;
    const { history, match } = this.props;
    const view = match.params.view;
    return (
      <Layout
        style={{
          "--primary-color": "rgb(19, 168, 158)",
          "--secondary-color": "rgb(23, 53, 94)"
        }}
      >
        <Header location={history.location} />

        {this.appContent(view)}

        {profile &&
          profile.email && (
            <LiveChat email={profile.email} name={profile.name} />
          )}
        <Footer />
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js